export const openEmailDraft = (buttonId) => {
  const emailConfig = {
    'book-briefing': {
      subject: 'Request for Executive Briefing',
      body: 'Hi Sanat,\n\nI would like to schedule a 15-minute briefing to learn more about your AI solutions for enterprise systems.\n\nBest regards,'
    },
    'view-solutions': {
      subject: 'Inquiry About Solutions',
      body: 'Hi Sanat,\n\nI am interested in learning more about your enterprise AI solutions.\n\nBest regards,'
    },
    'tell-us-needs': {
      subject: 'Custom Solution Inquiry',
      body: 'Hi Sanat,\n\nI would like to discuss a custom AI solution tailored to our specific needs.\n\nBest regards,'
    },
    'request-security': {
      subject: 'Request for Security Details',
      body: 'Hi Sanat,\n\nI would like to receive more information about your security controls and deployment options.\n\nBest regards,'
    },
    'book-value-briefing': {
      subject: 'Request for Briefing',
      body: 'Hi Sanat,\n\nI would like to schedule a briefing to discuss the value proposition and ROI of your solutions.\n\nBest regards,'
    },
    'general-contact': {
      subject: '',
      body: ''
    }
  };

  const config = emailConfig[buttonId];
  if (!config) return;

  const email = 'sanat.bhalla0704@gmail.com';
  const subject = encodeURIComponent(config.subject);
  const body = encodeURIComponent(config.body);
  
  window.location.href = `mailto:${email}?subject=${subject}&body=${body}`;
};
